<template>
   <el-card>
     <el-form :inline="true" :model="searchFactor" class="search-form">
        <el-form-item label="办事指南主题:" >
          <el-input v-model="searchFactor.theme"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleCreateGuid">创建</el-button>
        </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      :stripe ="true"
      :border = "true"
      height="calc(100vh - 200px)"
      :max-height="800"
      :highlight-current-row ="true"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 100%">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        prop="theme"
        label="主题"
        width="150" >
      </el-table-column>
      <el-table-column
        prop="content"
        label="内容"
        min-width="250" :formatter="formatContent">
      </el-table-column>
      <el-table-column
        prop="initFolderName"
        label="资源文件夹"
        width="180">
      </el-table-column>
      <el-table-column
        prop="attachFileName"
        label="附件名称"
        width="180">
      </el-table-column>
      <el-table-column
      prop="active"
      width="70"
      label="状态" >
      <template slot-scope="scope">
          <span v-if = "scope.row.active == 0" style="color: red"> 未发布</span>
          <span v-else style="color: greenyellow" > 已发布</span>
      </template>
    </el-table-column>
      <el-table-column
        prop="createUser"
        label="创建者"
        width="120">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="100">
      </el-table-column>
      <el-table-column
        prop="updateUser"
        width="120"
        label="更新者">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        width="100"
        label="更新时间">
      </el-table-column>
      <el-table-column label="操作" min-width="120px">
        <!-- <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleEditGuid(scope.$index, scope.row)">编辑</el-button>
            <el-button
            size="mini"
            type="primary"
            @click="handleViewEditor(scope.$index, scope.row)">预览</el-button>
            <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            <el-button
            size="mini"
            type="danger"
            @click="handleDeleteAttach(scope.$index, scope.row)">删除附件</el-button>
            <el-upload
              style="display: inline-block"
              ref='upload'
              :action="guidAttach.url"
              :headers="guidAttach.headers"
              :multiple="false"
              :limit="guidAttach.limit"
              :name="guidAttach.file"
              :on-success="fileUpLoadSuccess"
              :show-file-list="false"
              :on-error="fileUpLoadError">
              <el-button   size="mini"   @click="handleUploadAttach(scope.$index, scope.row)">添加附件</el-button>
            </el-upload>
            <el-button
          size="mini" 
          :type="scope.row.active == 0 ? 'warning' :'success'"
          @click="doActiveGuid(scope.$index, scope.row)">{{scope.row.active == 0?'发布':'撤销'}}</el-button>
        </template> -->
        <template slot-scope="scope" >
          <el-dropdown split-button type="primary" @command="handleCommand">
            管理
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided :command = '{event:"doActiveGuid",index:scope.$index, data:scope.row}'>
                <i :class="scope.row.active == 0 ? 'el-icon-star-on':'el-icon-star-off' "  :style="scope.row.active == 0 ?'color:rgb(40, 238, 10)' :'color:rgb(246, 102, 18)'" ></i> 
                <span>{{scope.row.active == 0?'发布':'撤销'}}</span>
              </el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleViewNotice",index:scope.$index, data:scope.row}'> <i class="el-icon-search" style="color:rgb(39, 193, 231)" ></i> <span>预览</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleEditNotice",index:scope.$index, data:scope.row}'><i class="el-icon-edit" style="color:rgb(41, 10, 239)" ></i> <span>编辑</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"uploadAttach", index:scope.$index,data:scope.row}'><i class="el-icon-upload2" style="color:rgb(40, 238, 10)" ></i> <span>上传附件</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleDeleteAttach",index:scope.$index, data:scope.row}'><i class="el-icon-delete" style="color:rgb(247, 33, 40)" ></i> <span>删除附件</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleDelete", index:scope.$index,data:scope.row}'><i class="el-icon-delete-solid" style="color:rgb(246, 102, 18)" ></i> <span>删除</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="pager.pageSize"
      :total="pager.totalCount">
    </el-pagination>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisual.initGuidThemeVisual" v-on:close ="clearInitGuidForm" >
      <div slot="title" class="dialog-footer">
        <span> 初始办事指南主题 </span>
      </div>
      <el-form  :model="initGuidForm" label-width="20%">
        <el-form-item  label="办事指南主题:" style="width:80%"> 
          <el-input v-model="initGuidForm.theme" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureCreate">创建</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" width="40%" :visible.sync="dialogVisual.initUploadAttachVisual" v-on:close ="clearUplaodAttachForm" >
      <div slot="title" class="dialog-footer">
        <span> 上传附件 </span>
      </div>
      <el-upload
        style="display: inline-block"
        ref='uploadAttach'
        :action="guidAttach.url"
        :headers="guidAttach.headers"
        :multiple="false"
        :limit="guidAttach.limit"
        :name="guidAttach.file"
        :on-success="fileUpLoadSuccess"
        :show-file-list="true"
        :on-error="fileUpLoadError">
        <el-button  size="mini"  @click="handleUploadAttach()">添加附件</el-button>
      </el-upload>
    </el-dialog>
  </el-card>
</template>                     
<script>
  // 引入组件
  import axios from  '@/api/axiosConfig'
  import {stringIsNullOrEmpty,getToken} from  '@/api/utils'
  import {PAGE_SIZE,MESSAGE_DURATION,fileAreaType,fileType} from  '@/api/constant'
  import SERVICE_URL  from  '@/api/url'
  export default {
      name : 'pc_ctr_guid_list',
      data() {
      return {
        searchFactor: {
          theme: '',
          createUser:''
        },
        dialogVisual:{
          initGuidThemeVisual: false,
          initUploadAttachVisual: false
        },
        initGuidForm:{
          theme:''
        },
        guidAttach :{
          headers: {token:""},
          url : "",
          limit : 1,
          name :"file",
          id:""
        },
        tableData: [],
        pager:{
          totalCount:0,
          pageSize : PAGE_SIZE
        }
      }
    },
    methods : {
      handleCommand(command){
        let index  = command.index
        let row = command.data
        let event = command.event
        switch(event){
          case 'handleDelete' :
              this.handleDelete(index,row)
              break
          case 'handleDeleteAttach' :
              this.handleDeleteAttach(index,row)
              break
          case 'handleEditNotice' :
              // this.handleEditNotice(index,row)
              let left =  (window.screen.availWidth-10-1000)/2
              let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
              width=1000,height=1000,left=${left},top=100`;
              window.open(SERVICE_URL + "/#/pc_ctr_guid_edit/" +row.id,"test",params);
              break
          case 'handleViewNotice':
              //this.handleViewNotice(index,row)
              // this.handleEditNotice(index,row)
              let left0 =  (window.screen.availWidth-10-1000)/2
              let params0 = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
              width=1000,height=1000,left=${left0},top=100`;
              window.open(SERVICE_URL+"/#/pc_ctr_editor_view/" +row.id +"?fileType=" + fileType.WORK_GUID,"test",params0);
              break
          case 'doActiveGuid':
              this.doActiveGuid(index,row)
              break
          case 'uploadAttach':
              this.uploadAttach(index,row)
              break
        }
      },
      indexMethod(index){
          return  index + 1
      },

      uploadAttach(index,row){
        this.dialogVisual.initUploadAttachVisual = true
        this.guidAttach.id = row.id
      },
      handleUploadAttach(){
        this.guidAttach.url = "/bc/exa/guid/upload?id=" + this.guidAttach.id + "&fileArea="+  fileAreaType.ATTACH
      },
      fileUpLoadSuccess(response, file, fileList){
        this.$refs.uploadAttach.clearFiles();
        if(response.code === 0){
          this.$message({
            showClose: true,
            message: '上传成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        }else{
          this.$message({
            showClose: true,
            message: response.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      },
      fileUpLoadError(err, file, fileList){
        this.$refs.uploadAttach.clearFiles();
        this.$message({
          showClose: true,
          message: err,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      },
      formatContent(row , index){
        if(row.content == null || row.content == ''){
          return ''
        }
        if(row.content.length > 400 ){
          return row.content.substring(0,400)
        }
        return row.content
      },
      handleCurrentChange(val){
        this.editorListLoad(val);
      },
      guidListLoad(pageNo){
        let _this = this
        let url = "/bc/exa/guid/guidPage"
        let { 
            theme
        } = this.searchFactor 
        let dat0 = {
            pageSize: PAGE_SIZE,
            theme,
            pageNo
        }
        axios.post(url, dat0).then((response) => {
          if (response.data.code === 0) {
            let dat = response.data.data;
            if(dat.data.length !== 0){
                this.tableData = [];
                dat.data.forEach(t=>this.tableData.push(t))
                this.pager.totalCount = dat.totalDataCount;
            } else {
              this.$message({
                showClose: true,
                message: '未查询到安全知识信息！',
                type: 'info',
                duration: MESSAGE_DURATION
              })
            }
          }else{
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
          }).catch((err)=>{
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          });
      },
      onSearch(){
        this.guidListLoad(1)
      },
      handleCreateGuid(){
        this.dialogVisual.initGuidThemeVisual = true;
      },
      handleViewEditor(index, row){
        this.$router.replace({ path:'pc_ctr_editor_view', query: {id: row.id}} )
      },
      handleDelete(index, row){
        this.$confirm('即将删除主题['+row.theme+']的办事指南!', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
          this.doDeleteGuid(row)
        }).catch((err) => {
          this.$message({
            type: 'info',
            message: err.message
          });
        })
      },
      doDeleteGuid(row){
        let datBat = {id: row.id}
        let url = "/bc/exa/guid/guidDelete"
        let s = JSON.stringify(datBat)  
        axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.$message({
              showClose: true,
              message: '删除成功!',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            this.guidListLoad(1);
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
        })
      },
      handleDeleteAttach(index, row){
        this.$confirm('即将删除主题['+row.theme+']的附件!', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doDeleteGuidAttach(row)
        }).catch((err) => {
          this.$message({
            type: 'info',
            message: err.message
          });
        })
      },
      doDeleteGuidAttach(row){
        let dat = {id: row.id}
        let url = "/bc/exa/guid/deleteAttach"
        let s = JSON.stringify(dat)  
        axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.$message({
              showClose: true,
              message: '删除成功!',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            this.guidListLoad(1);
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
        })
      },
      doActiveGuid(index,row){
        let actState = row.active === 0 ? 1 : 0
        let dat = {
          id: row.id,
          active: actState
        }
        let url = "/bc/exa/guid/guidActive"
        let s = JSON.stringify(dat)  
        axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.$message({
              showClose: true,
              message: '操作成功!',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            this.guidListLoad(1);
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
        })
      },
      handleEditGuid(index,row){
        this.$router.replace({ path:'pc_ctr_guid_change',query: {id: row.id} })
      },
      ensureCreate(){
        let theme = this.initGuidForm.theme.trim();
        try{ 
          stringIsNullOrEmpty(theme,'请输入安全知识主题!');
        }catch (e){
          this.$message({
            showClose: true,
            message: e,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
          return
        }
        let dat = {
          theme : theme
        }
        let url = "/bc/exa/guid/save"
        let s = JSON.stringify(dat)  
        axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.dialogVisual.initGuidThemeVisual = false;
            this.$message({
              showClose: true,
              message: '初始化办事指南成功',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            this.clearInitGuidForm()
            setTimeout(()=>{this.guidListLoad(1)},200)
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err)=> {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
        })
      },
      clearInitGuidForm(){
        this.initGuidForm.theme = ''
      },
      clearUplaodAttachForm(){
        this.guidAttach.id = ''
        this.guidAttach.url= ""
      }
    },
    created () {
      setTimeout(()=>{getToken(this.guidAttach.headers)},200)
      this.guidListLoad(1);
    },
    components: {
      
    }
  }
</script>

<style lang="less" scoped>
.el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}
</style>
  


// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_guid_list.vue